import { bannerStates } from '@constants/index';

const processCarouselEntity = (feedBlock) => ({
  label: feedBlock.label || feedBlock.extraBlockInfo.label || '',
  type: feedBlock.type,
  carouselFeed: (feedBlock.data || []).map((item) => {
    return {
      bannerDetails: {
        uid: item.uid,
        title: item.title,
        description: item.description,
        type: item.bannerType,
        bannerPhoto: item.bannerPhoto,
        clickURL: item.clickUrl
      },
      course:
        item.bannerType === bannerStates.ITEM
          ? item.sessionInfo.courseInfo
          : item.sessionInfo,
      sessionData: item.sessionInfo
    };
  }),
  extraBlockinfo: {
    ...(feedBlock.extraBlockInfo || {})
  }
});

export default processCarouselEntity;
